import { HttpContextToken, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';

/** No `HttpContext` da requisição: não acionar o spinner de tela cheia (o visualizador tem o seu estado por camada). */
export const SKIP_LOADING = new HttpContextToken<boolean>(() => false);

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private activeRequests = 0;

  urlExcepted = ['upload-image-or-pdf'];

  constructor(private loadingService: LoadingService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.context.get(SKIP_LOADING)) return next.handle(request);

    const isExcepted = this.urlExcepted.some(url => request.url.includes(url));
    // console.log('Interceptor called:', request.url)
    if (this.activeRequests === 0 && !isExcepted) {
      this.loadingService.show();
    }

    this.activeRequests++;

    return next.handle(request).pipe(
      finalize(() => {
        this.activeRequests--;

        if (this.activeRequests === 0) {
          this.loadingService.hide();
        }
      })
    );
  }
}
